/**
 * Smart charging (Phase G).
 *
 * Prefer the "sugar" endpoints (`setMaxKw`, `setSiteCap`) over hand-built
 * profiles for the primary UX. The full editor is power-user territory.
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  ClearChargingProfileFilter,
  ClearChargingProfileResponse,
  CompositeScheduleQuery,
  CompositeScheduleResponse,
  ListChargingProfilesResponse,
  MaxKwBody,
  SetChargingProfileBody,
  SetChargingProfileResponse,
  SiteCapBody,
} from '../models';

export const listChargingProfiles = (chargerId: string) =>
  ocppRequest<ListChargingProfilesResponse>({
    method: 'GET',
    path: `smart/${enc(chargerId)}`,
  });

export const setChargingProfile = (chargerId: string, body: SetChargingProfileBody) =>
  ocppRequest<SetChargingProfileResponse>({
    method: 'POST',
    path: `smart/${enc(chargerId)}`,
    body,
  });

export const clearChargingProfile = (chargerId: string, filter: ClearChargingProfileFilter = {}) =>
  ocppRequest<ClearChargingProfileResponse>({
    method: 'DELETE',
    path: `smart/${enc(chargerId)}`,
    body: filter,
  });

export const getCompositeSchedule = (chargerId: string, q: CompositeScheduleQuery) =>
  ocppRequest<CompositeScheduleResponse>({
    method: 'GET',
    path: `smart/${enc(chargerId)}/composite-schedule`,
    query: {
      duration_seconds: q.duration_seconds,
      charging_rate_unit: q.charging_rate_unit,
      connector_id: q.connector_id,
      evse_id: q.evse_id,
    },
  });

export const setMaxKw = (chargerId: string, body: MaxKwBody) =>
  ocppRequest<SetChargingProfileResponse>({
    method: 'POST',
    path: `smart/${enc(chargerId)}/max-kw`,
    body,
  });

export const setSiteCap = (chargerId: string, body: SiteCapBody) =>
  ocppRequest<SetChargingProfileResponse>({
    method: 'POST',
    path: `smart/${enc(chargerId)}/site-cap`,
    body,
  });
